const comBg = (() => {
  if (document.querySelector("section#jsComSecBg") !== null) {



    let secBg = document.querySelector('#jsComSecBg');
    let videoBox = secBg.querySelector('.js-video-box');

    VanillaTilt.init(videoBox, {
      reverse: true,  // 傾きの方向を逆にする
      max: 8,  // 最大傾き回転角度（度）
      // startX: 0,  // X軸の開始傾き、度単位
      // startY: 0,  // Y軸の開始傾き、度単位
      perspective: 1000,  // 変換の透視距離、値が小さいほど傾きがより極端になる
      scale: 1,  // 拡大率。2=200%、1.5=150%、など
      speed: 300,  // 入退場時の動作速度
      transition: true,  // 入退場時にトランジションを設定する
      // axis: null,  // 有効にする軸。 "x"または"y"になり得る
      reset: true,  // 退出時に傾き効果をリセットするかどうか
      // "reset-to-start": true,  // 退出時のリセット地点を[0,0]（デフォルト）か[startX, startY]にするか
      // easing: "cubic-bezier(.03,.98,.52,.99)",  // 入退場時のイージング
      // glare: false,  // "グレア"効果を持たせるかどうか
      // "max-glare": 1,  // 最大の "グレア" 不透明度（1=100%、0.5=50%）
      // "glare-prerender": false,  // falseの場合、VanillaTiltがグレアの要素を自動生成。trueの場合は自分で要素を追加
      "mouse-event-element": 'body',  // CSSセレクタまたはHTML要素のリンク。マウスイベントを監視する要素
      gyroscope: true,  // デバイスの方位センサー（ジャイロスコープ）を有効/無効にする
      // gyroscopeMinAngleX: -45,  // X軸のデバイス角度の下限。これ以上傾くと要素が左端のように傾く
      // gyroscopeMaxAngleX: 45,  // X軸のデバイス角度の上限。これ以上傾くと要素が右端のように傾く
      // gyroscopeMinAngleY: -45,  // Y軸のデバイス角度の下限。これ以上傾くと要素が上端のように傾く
      // gyroscopeMaxAngleY: 45,  // Y軸のデバイス角度の上限。これ以上傾くと要素が下端のように傾く
    });



    if (document.querySelector("body#pageTop") !== null) {

      let secMain = document.querySelector('#jsSecMain');
      let coverBox = secBg.querySelector('.js-cover-box');

      let to = gsap.to(coverBox, {
        opacity: 0.9,
        ease: "none",
        scrollTrigger: {
          trigger: secMain,
          start: '100% 100%',
          end: '100% 50%',
          scrub: 0,
          // markers: true
        }
      })

      let target = document.querySelector('body');
      let observer = new ResizeObserver((entries) => {
        entries.forEach((entry) => {
          to.scrollTrigger.refresh()
        });
      });
      observer.observe(target);

    }



  }
})()
export default comBg;